import { getFiles, setWidget } from "backend/store.web";
import wixLocation from 'wix-location';
import { getInstance, getSubscription } from 'public/Utilities/subscription'
import { viewMode } from 'wix-window-frontend';

var store = require('store');

$w.onReady(async function () {
    // console.log('[Files and PDfs] onReady v1.7');
    handleInitialStates();
    const { instanceId } = await getInstance();
    store.set('instanceId', instanceId);
    store.set('props', $widget.props);

    if (viewMode == 'Editor' || viewMode == 'Site') {
        try {
            await setWidget(instanceId, viewMode);
        } catch (error) {
            console.error('setWidget ~ error:', error);
        }
    }

    //await checkSubscription();
    // await fetchFiles();
    // populateRepeaterWithFiles();
    // handleElementChanges();
});

$widget.onPropsChanged(async (oldProps, newProps) => {
    store.set('props', newProps);
    store.set('oldProps', oldProps);
    if (isPropChanged('productId') || newProps.isRefreshRequested) {
        await fetchFiles();
    }
    populateRepeaterWithFiles();
    handleElementChanges();
    changeTemplate();
});

function handleInitialStates() {

    if (viewMode === 'Editor') {
        $w('#templateMultiStateBox').changeState('loadingState');
    } else {
        $w('#templateMultiStateBox').changeState('emptyState');
    }
    $w('#titleBox').changeState('titleEmptyState');
    $w('#templateBannerAlertMultiStateBox').changeState('templateBannerEmptyState');
    $w('#freeTrialMultiStateBox').changeState('freeTrialEmptyState');
}

function handleElementChanges() {
    changeTitleVisibility();
    changeDesign();
}

async function changeTemplate() {
    const { template } = store.get('props');
    $w(`#templateMultiStateBox`).changeState(`Temp${template}`);
}

async function changeDesign() {
    const { template, design } = store.get('props');
    $w(`#Temp${template}MultiState`).changeState(`Temp${template}MultiStateDesign${design}`);
}

async function changeTitleVisibility() {
    const { showTitle } = store.get('props');
    if (showTitle) {
        $w('#titleBox').expand();
    } else {
        $w('#titleBox').collapse();
    }
}

async function fetchFiles() {
    const DEFAULT_FILES = [
        { fileName: "First file.pdf" },
        { fileName: "Second file.doc" },
        { fileName: "Third file.txt" }
    ];
    store.set('fileList', DEFAULT_FILES);

    try {
        let instanceId = store.get('instanceId');
        if(!instanceId) {
            const instance = await getInstance();
            instanceId = instance.instanceId
        }
        const { productId } = store.get('props');
        if (!productId) return;

        const response = await getFiles(instanceId, productId);
        const fileList = response?.data?.files ?? null;
        const isFilesAvailable = fileList && fileList.length > 0;

        if (isFilesAvailable) {

            // handleWarningMsgVisibility(false);
            $w('#titleBox').changeState('titleState');
            $w('#templateBannerAlertMultiStateBox').changeState('templateBannerEmptyState');
            changeTemplate();

            $w('#widgetContainer').expand();
            store.set('fileList', fileList);
            populateRepeaterWithFiles();
        } else {
            // handleWarningMsgVisibility(true);
            

            // $w('#widgetContainer').expand();

            // hideWidget();

            if (viewMode === 'Editor') {
                $w('#titleBox').changeState('titleState');
                $w('#templateBannerAlertMultiStateBox').changeState('templateBannerState');
                changeTemplate();
                store.set('fileList', DEFAULT_FILES);
                populateRepeaterWithFiles();
                $w('#widgetContainer').expand();
            } else {
                $w('#widgetContainer').collapse();
                return;
            }
        }
    } catch (error) {
        console.error("Error retrieving files data:", error);
        // hideWidget();
        $w('#widgetContainer').collapse();
    }
}

// async function handleWarningMsgVisibility(showWarning) {
//     $w('#templateBannerAlertMultiStateBox').changeState(
//         !showWarning ? 'templateBannerEmptyState' : 'templateBannerState'
//     );
// }

async function populateRepeaterWithFiles() {
    const { productId } = store.get('props');
    if (!productId) return;

    const fileList = store.get('fileList') || [];
    const { template, design, showFileExtension } = store.get('props');

    const repeater = $w(`#Temp${template}Design${design}Repeater`);

    const formattedFileList = fileList.map((file, index) => {
        const fileName = file.fileName || file.name;
        const fileParts = fileName.split('.');
        const fileNameWithoutExt = fileParts[0];
        const fileType = fileParts[1] || '';

        return {
            _id: `item${index + 1}`,
            fileNameWithoutExtension: fileNameWithoutExt,
            fileType: fileType,
            downloadUrl: file.url,
            fileName: fileName,
            size: file.size
        };
    });

    repeater.data = formattedFileList;

    repeater.forEachItem(($item, itemData) => {

        if (itemData.fileType) {
            const iconState = `Temp${template}Design${design}${itemData.fileType}`;
            $item(`#Temp${template}Design${design}IconMultiState`).changeState(iconState);
        } else {
            // To-Do
            const placeholderIconState = `Temp${template}Design${design}placeholder`;
            $item(`#Temp${template}Design${design}IconMultiState`).changeState(placeholderIconState);
            // console.log("Missing fileType for item:", itemData);
        }

        let fileDisplayName = showFileExtension ? itemData.fileName : itemData.fileNameWithoutExtension;
        $item(`#Temp${template}Design${design}Text`).text = fileDisplayName;

        $item(`#Temp${template}Design${design}RepeaterItem`).onClick(() => {
            wixLocation.to(itemData.downloadUrl);
        });
    });
}

function isPropChanged(propName) {
    const newProps = store.get('props');
    const oldProps = store.get('oldProps');
    return newProps[propName] !== oldProps[propName];
}

// function hideWidget() {
//     const isPreview = viewMode != 'Editor';
//     if (isPreview) $w('#widgetContainer').collapse();
// }

//function for check subscription
// export async function checkSubscription() {
//     let subscription = await getSubscription();

//     if (subscription.isPremium) {
//         $w('#templateMultiStateBox').restore();
//         $w('#freeTrialBanner').delete();
//     } else {
//          if (viewMode == 'Site') {
//             $w('#widgetContainer').delete();
//         } else if (viewMode == 'Editor') {
//             $w('#widgetContainer').restore();
//             $w('#freeTrialBanner').restore();
//             $w('#templateMultiStateBox').restore();
//         }else if(viewMode == 'Preview'){
//             $w('#widgetContainer').restore();
//             $w('#templateMultiStateBox').restore();
//         }
//     }
// }